"use strict";
/**
 * MANRuntime Container for registering Resources, Services, and Workflows.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANRuntime = void 0;
class MANRuntime {
    static _instance;
    resources = new Map();
    services = new Map();
    workflows = new Map();
    installedPlugins = new Set();
    static getInstance() {
        if (!MANRuntime._instance) {
            MANRuntime._instance = new MANRuntime();
        }
        return MANRuntime._instance;
    }
    // --- Resource Registration ---
    registerResource(resource) {
        if (this.resources.has(resource.name)) {
            console.warn(`[MANRuntime] Resource '${resource.name}' already registered. Overwriting.`);
        }
        this.resources.set(resource.name, resource);
    }
    getResource(name) {
        const resource = this.resources.get(name);
        if (!resource) {
            throw new Error(`[MANRuntime] Resource '${name}' not found in runtime.`);
        }
        return resource;
    }
    // --- Service Registration ---
    registerService(name, service) {
        this.services.set(name, service);
    }
    getService(name) {
        const service = this.services.get(name);
        if (!service) {
            throw new Error(`[MANRuntime] Service '${name}' not found in runtime.`);
        }
        return service;
    }
    // --- Workflow Registration ---
    registerWorkflow(workflow) {
        this.workflows.set(workflow.name, workflow);
    }
    getWorkflow(name) {
        const workflow = this.workflows.get(name);
        if (!workflow) {
            throw new Error(`[MANRuntime] Workflow '${name}' not found in runtime.`);
        }
        return workflow;
    }
    // --- Plugin Installation ---
    async usePlugin(plugin) {
        if (this.installedPlugins.has(plugin.name)) {
            console.warn(`[MANRuntime] Plugin '${plugin.name}' already installed.`);
            return;
        }
        await plugin.install(this);
        this.installedPlugins.add(plugin.name);
    }
    // --- Lifecycle Management ---
    async startAll() {
        for (const resource of Array.from(this.resources.values())) {
            await resource.start();
        }
    }
    async stopAll() {
        for (const resource of Array.from(this.resources.values())) {
            await resource.stop();
        }
    }
    async healthCheck() {
        const reports = [];
        for (const resource of Array.from(this.resources.values())) {
            reports.push(await resource.healthCheck());
        }
        return reports;
    }
}
exports.MANRuntime = MANRuntime;
